import Cookies from 'js-cookie';
import {localStorage} from 'utils/Helper';

export function hasPermission(permissionId) {
    const permissionsCookie = Cookies.get('p') || '';
    const permissions = permissionsCookie.split('-');

    return permissions && permissions[permissionId];
}

export function set(newUserData = {}) {
    const userData = localStorage('get', 'user');
    localStorage('set', 'user', {...userData, ...newUserData});
}

export function get(keyName = '') {
    if (keyName) {
        // 
    }
    return localStorage('get', 'user') || {};
}